import * as React from 'react';
import { Button } from 'Src/components/Button/Button';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';

type Props = {
  isOpen: boolean;
  isBulkDisabling: boolean;
  manageSelectedCount: number;
  manageSelectedDisabledCount: number;
  manageSelectedEnabledCount: number;
  bulkProgress: { done: number; total: number };
  onClose: () => void;
  onConfirm: () => void;
};

export const ClubProgrammeManageClubsRemoveSelectedModal: React.FC<Props> = ({
  isOpen,
  isBulkDisabling,
  manageSelectedCount,
  manageSelectedDisabledCount,
  manageSelectedEnabledCount,
  bulkProgress,
  onClose,
  onConfirm
}) => {
  return (
    <SimpleModal
      isOpen={isOpen}
      title={manageSelectedCount === 1 ? 'Remove club?' : 'Remove selected clubs?'}
      buttonCancelText="Cancel"
      onCloseClick={onClose}
      customClass="pcRemoveClubsModal"
      dialogStyle={{ maxWidth: 480 }}
      showFooter={false}
    >
      <div className="pcRemoveClubsContent">
        <div className="pcRemoveClubsIcon" aria-hidden="true">
          ×
        </div>
        <div>
          <p>
            {manageSelectedCount === 1
              ? 'The selected club will be removed from this programme.'
              : `${manageSelectedDisabledCount} disabled clubs will be removed from this programme.`}
          </p>
          {manageSelectedEnabledCount > 0 ? (
            <p className="pcRemoveClubsNote">
              {manageSelectedEnabledCount} enabled {manageSelectedEnabledCount === 1 ? 'club is' : 'clubs are'} not
              included. Disable {manageSelectedEnabledCount === 1 ? 'it' : 'them'} before removing.
            </p>
          ) : null}
          <p className="pcRemoveClubsWarning">
            This action cannot be undone, although the clubs can be added again later.
          </p>
        </div>
      </div>

      <div className="pcRemoveClubsActions">
        <Button text="Cancel" onClick={onClose} disabled={isBulkDisabling} customClass="sit-btn sit-btn--secondary" />
        <Button
          text={
            isBulkDisabling
              ? `Removing… (${bulkProgress.done}/${bulkProgress.total})`
              : `Remove (${manageSelectedDisabledCount})`
          }
          onClick={onConfirm}
          disabled={isBulkDisabling || manageSelectedDisabledCount === 0}
          customClass="sit-btn pcRemoveClubsConfirm"
        />
      </div>
    </SimpleModal>
  );
};
